<template>
  <div class="box8" id="box8">
    <pageTitle
      title="0基础转行无压力"
      text="据传智内部学生调研结果显示<br/>各期零基础的学生平均占90%以上"
      titleColor="#191c47"
      titColor="#666666"
      class="pageTitle"
    />
    <div class="wrap">
      <p class="p1">如果你</p>
      <div class="point">
        <p>爱观察</p>
        <p>擅沟通</p>
        <p>有想法</p>
      </div>
      <span
        >在博学谷真项目强师资的加持下，不同行业、不<br />同专业背景的学生<i
          >均可成功转行<i></i></i
      ></span>
    </div>
    <div class="scrollBox">
      <div class="heng">
        <div
          class="item"
          v-for="(item, index) in list.slice(0, 7)"
          :key="index"
        >
          {{ item }}
        </div>
        <div class="seat"></div>
      </div>
      <div class="heng">
        <div
          class="item"
          v-for="(item, index) in list.slice(7, 15)"
          :key="index"
        >
          {{ item }}
        </div>
        <div class="seat"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        "策划",
        "老师",
        "设计",
        "运营",
        "行政",
        "前端开发",
        "研究员",
        "管理",
        "商务",
        "销售",
        "客服",
        "会计",

        "后期制作",
        "市场营销",
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box8 {
  padding: 80px 0 58px;

  width: 100%;
  background: url("../../../assets/coursePage/pm/box8/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;

  .wrap {
    width: 690px;
    height: 364px;
    overflow: hidden;
    margin: 48px auto 16px;
    background: url("../../../assets/coursePage/pm/box8/content.png") no-repeat;
    border-radius: 16px;
    background-size: cover;
    .p1 {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #191c47;
      line-height: 40px;
      text-align: center;
      margin: 50px 0 32px;
    }
    .point {
      display: flex;
      justify-content: space-between;
      padding: 0 48px;
      box-sizing: border-box;

      p {
        width: 176px;
        height: 72px;
        background: linear-gradient(227deg, #ba6eff 0%, #8883fe 100%);
        border-radius: 36px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 72px;
        text-align: center;
      }
    }
    span {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-top: 48px;
      text-align: center;
      display: block;
      i {
        position: relative;
        z-index: 3;
        font-family: PingFangSC-Medium, PingFang SC;
        i {
          display: block;
          width: 170px;
          height: 18px;
          background: #ebddfe;
          position: absolute;
          bottom: -2px;
          left: 0;
          z-index: -1;
        }
      }
    }
  }
  .scrollBox::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scrollBox {
    overflow-x: auto;
    .seat {
      width: 8px;
      flex-shrink: 0;
    }
    .heng:nth-child(1) {
      .item:nth-child(7) {
        width: 156px;
        box-sizing: border-box;
        text-align: center;
      }
    }
    .heng {
      display: flex;
      margin-left: 32px;
      margin-bottom: 30px;
      .item {
        flex-shrink: 0;
        height: 64px;
        background: #ffffff;
        box-shadow: 0px 0px 32px 0px rgba(237, 223, 255, 0.5);
        border-radius: 8px;
        border: 2px solid #ffffff;
        padding: 0 24px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 64px;
        margin-right: 24px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
